export type MarketView = "Capacity" | "Requests" | "Contracts";

export function reservedPath(view: MarketView = "Capacity") {
  return view === "Capacity" ? "/reserved-compute" : `/reserved-compute/${view.toLowerCase()}`;
}

export function legacyReservedSearch(search: Record<string, unknown>): { request?: true; view?: MarketView } {
  return {
    ...([true, "true", 1, "1"].includes(search.request as string | number | boolean) ? { request: true as const } : {}),
    ...(search.view === "Requests" || search.view === "Contracts" ? { view: search.view } : {}),
  };
}
